// extracted by mini-css-extract-plugin
export default {"divider":"styles_divider__-4j6X","option_tag":"styles_option_tag__Dub6c"};